import ViewPropTypes from "../View/ViewPropTypes";
export default ViewPropTypes;